<div class="row mb-3 mt-2">
  <div class="col-12 col-md-6">
    <button class="btn btn-secondary text-white m-r-10" (click)="activeChange.emit(false)">Volver</button>
  </div>

  <div class="col-12 col-md-6">
    <div class="mb-3 d-md-flex justify-content-end align-items-center gap-3 fw-bold">
      <div class="mt-md-0">
        <a (click)="syncAccounts()" class="text-decoration-none text-dark" role="button" style="cursor: pointer;">
          <i class="fa fa-sync fa-fw me-1 text-dark text-opacity-50"></i> Sincronizar cuentas Aasinet
        </a>
      </div>
      <button class="btn btn-success text-white" (click)="openModalAccount()">Agregar Cuenta</button>
    </div>
  </div>
</div>

<div [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x, 'position': 'absolute'}">
  <app-context-menu #contextMenu></app-context-menu>
</div>

<div class="panel p-4 ">

<div class="table-responsive table-data">
    <table class="table table-sm table-striped ">
        <thead>
            <tr>
                <th class="text-nowrap " style="width: 80px;">N° Cuenta</th>
                <th>Subcuenta</th>
                <th>Nombre Cuenta </th>
                <th class="text-nowrap ">Notas</th>
                <th class="text-nowrap ">Activo</th>
                <th class="text-nowrap text-center"><i class="fas fa-cog"></i></th>
                
                  
            </tr>
        </thead>
        <tbody>
            @for(a of dataSource; track a){
            <tr>
                <td class="text-nowrap align-middle  text-center"style="height: 34px;">{{a.accountCode}}
                </td>
                <td class=" align-middle">{{a.subAccountCode==-1?'':a.subAccountCode}}</td>
                <td class=" align-middle">{{a.subAccountCode==-1?a.displayName:a.displayName+' - '+a.subAccountName}}</td>
                <td class="text-nowrap align-middle">
                    <span >{{a.hint}}</span>
                </td>
                <td class="text-nowrap align-middle">
                    <span > <input class="form-check-input" type="checkbox" [checked]="a.isActive" (change)="updateAccountCheck(a,'isActive',!a.isActive)"> </span>
                </td>
                <td class="text-nowrap  text-center">
                  <div class="d-flex gap-1 justify-content-center">
                    <button class="btn btn-outline-primary btn-xs" (click)="setFormAccount(a)"><i class="fas fa-pencil-alt"></i></button>
                      <button class="btn btn-outline-danger btn-xs" (click)="deleteAccount(a)"><i class="fas fa-trash"></i></button>
                    
                  </div>
                </td>
              
            </tr>
            }
        </tbody>
    </table>
</div>





</div>


<br>



<ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{titleModal}}</h5>
    <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
      <span></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formAccount">
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Nombre personalizado</label>
        <div class="col-md-8">
          <input type="text" #nameInput
            [class.is-invalid]="formAccount.get('displayName').invalid&&formAccount.get('displayName').touched"
            (click)="formAccount.get('displayName').markAsUntouched();" placeholder="Nombre personalizado"
            (focus)="formAccount.get('displayName').markAsUntouched();" formControlName="displayName"
            name="displayName" class="form-control" tabindex="1" />
          @if(formAccount.get('displayName')?.errors?.required &&
          formAccount.get('displayName').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Código</label>
        <div class="col-md-8">
          <ng-select #ngSelect [hideSelected]="true" [items]="account" bindLabel="nameCode" [closeOnSelect]="true"
            [dropdownPosition]="'bottom'" bindValue="accountCode" placeholder="Escribe una cuenta o codigo"
            formControlName="accountCode" name="accountCode"  tabindex="2" (change)="changeNgSelect()">
          </ng-select>
          @if(formAccount.get('accountCode')?.errors?.required &&
          formAccount.get('accountCode').touched){
          <div><small class="text-danger">Cuenta es requerida.</small></div>
          }
        </div>
      </div>&nbsp;

      <div class="form-group row">
        <label class="col-md-4 col-form-label">Sub Cuenta</label>
        <div class="col-md-8">
          <ng-select #ngSelect [hideSelected]="true" [items]="subAccountNgSelect" bindLabel="nameCode" [closeOnSelect]="true"
            [dropdownPosition]="'bottom'" bindValue="subAccountCode" placeholder="Escribe una cuenta o codigo" (change)="changeNgSelectSubAccount($event)"
            formControlName="subAccountCode" name="subAccountCode"  tabindex="3"
            >
          </ng-select>
          @if(formAccount.get('subAccountCode')?.errors?.required &&
          formAccount.get('subAccountCode').touched){
          <div><small class="text-danger">La subcuenta es requerida.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Inf Campo</label>
        <div class="col-md-8">
          <textarea #input type="text"
            [class.is-invalid]="formAccount.get('hint').invalid&&formAccount.get('hint').touched"
            (click)="formAccount.get('hint').markAsUntouched();"
            (focus)="formAccount.get('hint').markAsUntouched();" formControlName="hint" name="hint"
            class="form-control" tabindex="4" rows="5">
          </textarea>
          @if(formAccount.get('hint')?.errors?.required && formAccount.get('hint').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
     
    </form>
  </div>
  <div class="modal-footer">
    @if(formAccount.errors){
    <div><small class="text-danger">{{formAccount.errors | json }}</small></div>
    }
    <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click'); resetForm()"><i
        class="fas fa-times"></i>&nbsp; Cerrar</button>
    @if(titleModal=='Editar Cuenta'){
    <button type="button" class="btn btn-primary btn-sm" (click)="submitUpdate()"
      [disabled]="formAccount.invalid||formAccount.pristine"
      tabindex="5"><i class="fas fa-save"></i>&nbsp;Guardar</button>
    }
    @if(titleModal=='Agregar Cuenta'){
    <button type="button" class="btn btn-primary btn-sm" (click)="submitNew()"
      [disabled]="formAccount.invalid||formAccount.pristine"
      
      tabindex="5"><i class="fas fa-save"></i>&nbsp;Guardar</button>
    }


  </div>

</ng-template>